<ion-header>
    <ion-toolbar #headerToolbar style="--background:var(--myDisabledEnabledColor)">
        <ion-buttons slot="start">
            <ion-back-button data-test="backButton" [disabled]=vb.disabled></ion-back-button>
        </ion-buttons>
        <ion-title data-test="title" #title (click)="onTitleClick()">Campaign Incentive</ion-title>
        <ion-buttons slot="end">
            <ion-button data-test="more" [disabled]=vb.disabled color="light" id="more" (click)="onMoreClick($event)">
                <ion-icon name="ellipsis-horizontal" data-test="more"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content class="background ion-no-padding">

    <ion-list lines="none" style="height: 1550px">
        <ion-list-header color="secondary">
            Enter the incentive details:
        </ion-list-header>

        <form name="form" (ngSubmit)="f.form.valid && onSaveClick(f)" #f="ngForm" novalidate>

            <!-- <ion-item>
                <ion-label class="ion-text-wrap" position="stacked">First Name</ion-label>
                <ion-input 
                    color="secondary" 
                    type="text" 
                    name="firstName" 
                    #firstName="ngModel"
                    [ngClass]="{ 'is-invalid': f.submitted && firstName.invalid }" 
                    required 
                    [(ngModel)]="user.firstName"
                    id="firstName" 
                    autofocus="true">
                </ion-input>
                @if (submitted && firstName.invalid) {
  <div>
                    <div class="validationErrorMsg">First name is required.</div>
                </div>
}
            </ion-item> -->

            <ion-item>
                <ion-label class="ion-text-wrap" position="stacked">Incentive Title</ion-label>
                <ion-input data-test="incentiveTitle" color="secondary" type="text" name="incentiveTitle" #incentiveTitle="ngModel"
                    [(ngModel)]="incentive.title" [ngClass]="{ 'is-invalid': f.submitted && incentiveTitle.invalid }"
                    required id="incentiveTitle" placeholder="Tire Rotation or Oil Change, Engine Rebuild, etc.">
                </ion-input>
                @if (submitted && incentiveTitle.invalid) {
  <div>
                    <div class="validationErrorMsg">Incentive Title is required..</div>
                </div>
}
            </ion-item>

            <ion-item>
                <ion-label class="ion-text-wrap" position="stacked">Line 1</ion-label>
                <ion-input color="secondary" type="text" [(ngModel)]="incentive.line1" name="line1"
                    data-test="line1"></ion-input>
            </ion-item>

            <ion-item>
                <ion-label class="ion-text-wrap" position="stacked">Line 2</ion-label>
                <ion-input color="secondary" type="text" [(ngModel)]="incentive.line2" name="line2"
                    data-test="line2"></ion-input>
            </ion-item>

            <ion-item>
                <ion-label class="ion-text-wrap" position="stacked">Line 3</ion-label>
                <ion-input color="secondary" type="text" [(ngModel)]="incentive.line3" name="line3"
                    data-test="line3"></ion-input>
            </ion-item>

            <ion-item>
                <ion-label class="ion-text-wrap" position="stacked">Line 4</ion-label>
                <ion-input color="secondary" type="text" [(ngModel)]="incentive.line4" name="line4"
                    data-test="line4"></ion-input>
            </ion-item>

            <ion-item>
                <ion-label class="ion-text-wrap" position="stacked">Line 5</ion-label>
                <ion-input color="secondary" type="text" [(ngModel)]="incentive.line5" name="line5"
                    data-test="line5"></ion-input>
            </ion-item>

            <ion-item>
                <ion-label class="ion-text-wrap" position="stacked">Line 6</ion-label>
                <ion-input color="secondary" type="text" [(ngModel)]="incentive.line6" name="line6"
                    data-test="line6"></ion-input>
            </ion-item>

            <ion-item>
                <ion-label class="ion-text-wrap" position="stacked">Line 7</ion-label>
                <ion-input color="secondary" type="text" [(ngModel)]="incentive.line7" name="line7"
                    data-test="line7"></ion-input>
            </ion-item>

            <ion-item>
                <ion-label class="ion-text-wrap" position="stacked">Note</ion-label>
                <ion-textarea color="secondary" type="text" rows="3" [(ngModel)]="incentive.note" name="note"
                    data-test="note">
                </ion-textarea>
            </ion-item>

            <ion-item>
                <ion-label class="ion-text-wrap" position="stacked">Button Text</ion-label>
                <ion-input color="secondary" type="text" [(ngModel)]="incentive.buttonText" name="buttonText"
                    placeholder="Click To Make Appointment" data-test="buttonText"></ion-input>
            </ion-item>

            <ion-item>
                <ion-label class="ion-text-wrap" position="stacked">Sequence Number</ion-label>
                <ion-input color="secondary" type="number" [(ngModel)]="incentive.sequenceNumber" readonly
                    name="sequence" data-test="sequenceNumber">
                </ion-input>
            </ion-item>

            <ion-item>
                <ion-label class="ion-text-wrap">
                    <span class="line1">Show Button</span><br />
                    <span class="line2">{{callButtonText(incentive.showCallButton)}}</span>
                </ion-label>
                <ion-toggle data-test="showCallButton" id="showCallButton" [(ngModel)]="incentive.showCallButton" name="callButton"></ion-toggle>
            </ion-item>
        </form>

        <ion-grid>
            <ion-row>
                <ion-col>
                    <ion-card class="default ion-text-center">
                        @if (incentive.title) {
  <ion-card-header color="medium">
                            @if (incentive.title) {
  <ion-card-title>{{incentive.title}}</ion-card-title>
}
                        </ion-card-header>
}

                        <ion-card-content class="ion-no-padding">
                            @if (incentive.line1) {
  <div>
                                @if (incentive.line1) {
  <h1 class="bold big">{{incentive.line1}}</h1>
}
                                <br />
                            </div>
}
                            <!-- 
                            @if (incentive.line2) {
  <h1 class="bold">{{incentive.line2}}</h1>
}
                            @if (incentive.line3) {
  <h1 class="bold">{{incentive.line3}}</h1>
}
                            @if (incentive.line4) {
  <h1 class="bold">{{incentive.line4}}</h1>
}
 -->
                            @if (incentive.line2 || incentive.line3 || incentive.line4) {
  <div>
                                <h1 class="bold">{{incentive.line2}}</h1>
                                <h1 class="bold">{{incentive.line3}}</h1>
                                <h1 class="bold">{{incentive.line4}}</h1>
                                <br />
                            </div>
}

                            @if (incentive.line5) {
  <h2 class="normal">{{incentive.line5}}</h2>
}
                            @if (incentive.line6) {
  <h2 class="normal">{{incentive.line6}}</h2>
}
                            <!-- @if (incentive.line7) {
  <h2 class="normal lastLine">{{incentive.line7}}</h2>
} -->
                            @if (incentive.line7) {
  <h2 class="normal ion-margin-bottom">{{incentive.line7}}</h2>
}

                            <!-- @if (incentive.note) {
  <h2 class="normal lastLine ion-text-start note">{{incentive.note}}</h2>
}                         -->
                            @if (incentive.note) {
  <h2 class="normal ion-margin-bottom ion-text-start note">
                                {{incentive.note}}</h2>
}
                        </ion-card-content>

                        @if (incentive.showCallButton) {
  <div class="card-footer">
                            <ion-row>
                                <ion-col>
                                    <ion-button class="ion-no-padding call-btn" expand="full">
                                        {{incentive.buttonText}}
                                        <!-- @if (incentive.buttonText) {
  <ion-icon slot="end" name="call"></ion-icon>
} -->
                                        <ion-icon slot="end" name="call"></ion-icon>
                                    </ion-button>
                                </ion-col>
                            </ion-row>
                        </div>
}
                    </ion-card>
                </ion-col>
            </ion-row>
        </ion-grid>
    </ion-list>
</ion-content>

<ion-footer>
    <ion-toolbar>
        <ion-button data-test="save" color="primary" [disabled]=vb.disabled expand="full" (click)="onSaveClick(f)">Save</ion-button>
    </ion-toolbar>
</ion-footer>